import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

type SproutIllustrationProps = {
  width?: number
  height?: number
  showCircles?: boolean
}

export const SproutIllustration: FunctionComponent<SproutIllustrationProps> = ({
  width = 110,
  height = 56,
  showCircles = true,
}) => {
  return (
    <Svg width={width} height={height} viewBox='0 0 110 56' fill='none'>
      {showCircles && (
        <>
          <Path
            d='M110 30.832C110 32.732 108.881 33.332 107.5 33.332C106.119 33.332 105 32.2127 105 30.832C105 29.4513 105.7 28.332 107.5 28.332C108.881 28.332 110 29.4513 110 30.832Z'
            fill='#FFCB3B'
          />
          <Path
            d='M5 30.832C5 32.732 3.88071 33.332 2.5 33.332C1.11929 33.332 0 32.2127 0 30.832C0 29.4513 0.7 28.332 2.5 28.332C3.88071 28.332 5 29.4513 5 30.832Z'
            fill='#FFCB3B'
          />
          <Path
            d='M30 12.082C30 13.982 28.8807 14.582 27.5 14.582C26.1193 14.582 25 13.4627 25 12.082C25 10.7013 25.7 9.58203 27.5 9.58203C28.8807 9.58203 30 10.7013 30 12.082Z'
            fill='#FFDF75'
          />
        </>
      )}
      <Path
        d='M59.2036 45.832C43.751 45.832 36.0786 52.707 35.4536 53.332C34.8286 53.957 35.4536 53.957 35.4536 53.957C35.4536 53.957 44.9964 55.2415 59.8942 55.2415C74.792 55.2415 84.7628 54.4138 86.7036 53.957C86.871 53.8957 87.1824 53.7259 86.7036 53.332C86.2247 52.9381 75.4733 45.832 59.2036 45.832Z'
        fill='#A87F5D'
      />
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M60.3419 12.9793C60.8326 13.1553 61.0851 13.6885 60.9058 14.1701C59.1611 18.8572 58.3612 25.2608 58.2908 31.6084C58.2205 37.9494 58.8788 44.1311 59.9872 48.347C60.1178 48.8436 59.8135 49.35 59.3077 49.4781C58.8018 49.6063 58.2859 49.3076 58.1553 48.8111C56.9934 44.3916 56.3274 38.0379 56.399 31.5882C56.4705 25.145 57.2788 18.5027 59.1287 13.5328C59.308 13.0511 59.8512 12.8033 60.3419 12.9793Z'
        fill='#A3C979'
      />
      <Path
        d='M63.0444 30.6582C77.6122 25.9226 76.0041 20.6299 74.6798 18.6799C73.3554 16.73 69.8553 16.9157 64.6525 21.9298C59.7598 26.6451 58.4091 30.101 57.6523 34.4652C59.4497 31.8653 60.514 31.4807 63.0444 30.6582Z'
        fill='#A3C979'
      />
      <Path
        d='M53.0171 28.801C40.0481 24.595 41.1463 18.7562 42.5884 16.6379C44.0304 14.5197 46.8833 15.071 51.5151 19.5245C55.8707 23.7124 57.3685 27.1297 57.3685 32.8866C55.7685 30.5774 55.2698 29.5316 53.0171 28.801Z'
        fill='#A3C979'
      />
      <Path
        d='M68.9094 0.851856C62.8635 -0.488215 57.4631 12.8301 58.5983 19.3299C59.6864 17.9672 60.5848 15.8943 62.2876 14.78C63.9903 13.6658 65.3934 12.3798 68.2472 9.85875C72.977 5.6803 71.8418 1.50184 68.9094 0.851856Z'
        fill='#A3C979'
      />
    </Svg>
  )
}
